import { render, staticRenderFns } from "./ArtistGallery.vue?vue&type=template&id=0a466657&scoped=true&"
import script from "./ArtistGallery.vue?vue&type=script&lang=js&"
export * from "./ArtistGallery.vue?vue&type=script&lang=js&"
import style0 from "./ArtistGallery.vue?vue&type=style&index=0&id=0a466657&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a466657",
  null
  
)

export default component.exports